export const ocupation = {
	showDetailButton: 'Ver Mais',
	hiddenDetailButton: 'Ver Menos',
	list: [
		{
			id: 1,
			title: 'Desenvolvedor Front-End',
			fromTo: 'dez. de 2023 – o momento',
			company: 'Arcotech',
			description: [
				{
					id: 1,
					text: `Utilizamos a metodologia Shape Up para o planejamento das sprints. Na maioria dos
					projetos, seguimos o fluxo Trunk-Based Development; contudo, há algumas exceções em que
					adotamos o GitFlow. Além disso, trabalho com diversas ferramentas de monitoramento, como
					ArgoCD, Analytics, Grafana e New Relic.`,
				},
				{
					id: 2,
					text: `No dia a dia, utilizo React com TypeScript e Zustand para o gerenciamento de estados da aplicação.
					Também trabalhamos com micro front-end utilizando module federation. Para testes unitários,
					usamos Jest, e no backend for frontend (BFF), utilizamos NestJS. Nossas aplicações estão hospedadas
					na AWS, com o CloudFront como CDN e Kubernetes para o gerenciamento dos containers Docker.`,
				},
			],
		},
		{
			id: 2,
			title: 'Desenvolvedor Front-End',
			fromTo: 'mai. de 2021 – dez. 2023 - 2 anos e 8 meses',
			company: 'Zenvia',
			description: [
				{
					id: 1,
					text: `Eu trabalho usando a metodologia Scrum no desenvolvimento de novas features,
						resolvendo Bugs e desenvolvendo testes de uma plataforma que tem o objetivo de geração
						de documentos desenho e implementação de jornadas digitais e chatbots`,
				},
				{
					id: 2,
					text: `Durante o dia-a-dia eu utilizo: NextJS + TypeScript + Redux Saga + Context API + Styled Components,
						para testes usamos Cypress(e2e), Jest(unitários), também implementamos jsDocs para comentar o objetivo das funções,
						aplicamos o conventional commits para manter os commits sucintos, eu também cuido de algumas libs,
						De componentes, tokens, ícones... Usamos Hotjar e Google Analytics para monitoria dos projetos`,
				},
			],
		},
		{
			id: 3,
			title: 'Desenvolvedor Front-End',
			fromTo: 'fev. de 2021 – ago. de 2021 - 7 meses',
			company: 'NovaHaus',
			description: [
				{
					id: 1,
					text: `Trabalhei com Angular em um Projeto para Gol, usando design atômico, bem-css, e ao
						contrário do Mobile First nós criávamos o Web para depois adaptar para mobile, também
						realizamos testes em outros browsers para ver se tinham o comportamento correto usando
						Cross Browser, o Kanban foi adotado para controlar o fluxo de trabalho, e o desgin era
						consultado através do Zeplin.`,
				},
				{
					id: 2,
					text: `Participei do desenvolvimento da intranet do poliedro, usando Next com TypeScript,
						Context para compartilhar estados, docker, Material UI... E os layout eram consultados
						no Figma, o design foi construído usando grid, e para refletir isso na tela usamos o
						componente Grid do Material UI.`,
				},
			],
		},
		{
			id: 4,
			title: 'Desenvolvedor Full Stack',
			fromTo: 'set de 2020 - jan de 2021 - 5 meses',
			company: 'NWB - Network Brasil',
			description: [
				{
					id: 1,
					text: `Desenvolvi um site de votações para o canal Desimpedidos, e uma interface para
						 apresentar todos esses dados para empresa.`,
				},
				{
					id: 2,
					text: `Participei do desenvolvimento do Xtrala(EJS/ React Native) uma plataforma que aproxima os
						fãs/talentos, onde o usuário pode comprar vídeos do talento desejado, também fiz o
						aplicativo para listar os pedidos do talento, mostrar o extrato, gravar e enviar os
						vídeos para o usuário.`,
				},
				{
					id: 3,
					text: `Desenvolvi atualizações no site da empresa usando Angular, criando novas telas e melhorando as
						antigas, também comecei a inserir um sistema de contabilidade.`,
				},
			],
		},
	],
};
